import {
    h,
    renderSlot,
    computed,
} from 'vue'

import './css/ABtn.scss'

import {
    click,
    ABtnRenderless
} from './model.js'

const ABtn = {
    name: 'ABtn',
    inheritAttrs: false,
    props: {
        label: {
            //type: String,
        },
        config: {
            type: Object,
            default: () => ({})
        },
        geometry: {
            type: String,
            default: null
        },
        fill: {
            type: String,
            default: null
        },
        shadow: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: null
        },
        bg: {
            type: String,
            default: null
        },
        state: {
            type: Object,
            default: () => ({})
        },
    },
    setup: (props, ctx) => {

        const {
            store,
        } = ABtnRenderless(props, ctx)

        const styles = computed(() => ({
            btn: {
                'a-btn': true,
                [props.geometry]: props.geometry && true,
                [props.fill]: props.fill && true,
                shadow: props.shadow,
                ...store.state,
                // ...ctx.attrs.class
            }
        }))

        const node = ctx.attrs.href ? 'a' : 'button'

        const renderButton = () => h(node, {
            onClick: $e => click($e, ctx, store),
            'aria-label': props.label ? props.label : 'Button',
            ...ctx.attrs,
            class: [
                styles.value.btn,
                ctx.attrs.class,
            ],
            style: {
                color: props.color,
                background: props.bg,
                ...ctx.attrs.style,
            },
        }, [
            h('span', {
                class: ['a-btn-inner']
            }, [
                beforeSlot(),
                contentSlot(),
                afterSlot(),
            ])
        ])

        const beforeSlot = () => (
            ctx.slots.before !== void 0 ?
                h('span', {
                    class: ['a-btn-before']
                }, renderSlot(ctx.slots, 'before')) :
                renderSlot(ctx.slots, 'before')
        )

        const afterSlot = () => (
            ctx.slots.after !== void 0 ?
                h('span', {
                    class: ['a-btn-after']
                }, renderSlot(ctx.slots, 'after')) :
                renderSlot(ctx.slots, 'after')
        )

        const contentSlot = () => (
            ctx.slots.content !== void 0 ?
                h('span', {
                    class: ['a-btn-title'],
                }, [renderSlot(ctx.slots, 'content')]) :
                renderSlot(ctx.slots, 'content', {}, () => [h('span', {
                    innerHTML: props.label,
                    class: ['a-btn-title'],
                })])
        )

        return () => {
            if (ctx.slots.default) {
                return renderSlot(ctx.slots, 'default', {
                    click: click,
                    ...props,
                    ...store,
                })
            } else {
                return renderButton()
            }
        }
    }
}

export {
    ABtn
}